module.exports = __webpack_public_path__ + "img/setting-active.c68fb8cc.svg";